import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import {
  TableCell,
  TableRow,
  IconButton,
  Tooltip
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Table from "../../../components/Table";
import { getAdminsRequest } from "../../../store/Admins/actions";
import {
  edit,
  deleteAction
} from "../../../store/ActionsBtn/actions";
import messages from "../../../assets/locale/messages";
import EmptyState from "../../../components/EmptyState";
import Pagination from "../../../components/Pagination";

const AdminsList = ({ lang }) => {
  const dispatch = useDispatch();
  const list = useSelector((state) => state.admins.list);
  const meta = useSelector((state) => state.admins.meta);
  const isLoading = useSelector((state) => state.loader);
  const currentAdmin = useSelector((state) => state.auth.login);

  const [page, setPage] = useState(1);
  const perPage = 10;

  const {
    cols: { name, email },
    admins: { deleteNotAllowedMsg },
    shared: { deleteLabel, editLabel }
  } = messages[lang];

  const handleEdit = (id) => {
    dispatch(edit(id));
  };

  const handleDelete = (id) => {
    dispatch(deleteAction(id));
  };

  useEffect(() => {
    function getAdmins() {
      dispatch(
        getAdminsRequest({ page: 1, items: perPage, paginate: true })
      );
    }
    getAdmins();
  }, []);

  const handlePagination = (event, page) => {
    setPage(page);
    dispatch(
      getAdminsRequest({
        page: page,
        items: perPage,
        paginate: true
      })
    );
  };

  return (
    <>
      <Table
        headlines={[name, email]}
        hasActions={true}
        rows={list.map((row) => (
          <TableRow className="table__row" key={row.id}>
            <TableCell className="table__cell" align="left">
              {row.name}
            </TableCell>
            <TableCell className="table__cell" align="left">
              {row.email}
            </TableCell>
            <TableCell className="table__cell" align="right">
              <Tooltip title={editLabel}>
                <span>
                  <IconButton
                    onClick={() => handleEdit(row.id)}
                    aria-label="edit"
                  >
                    <EditIcon
                      className="table__edit"
                      fontSize="medium"
                    />
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip
                title={
                  currentAdmin.id === row.id
                    ? deleteNotAllowedMsg
                    : deleteLabel
                }
              >
                <span>
                  <IconButton
                    onClick={() => handleDelete(row.id)}
                    aria-label="delete"
                    disabled={currentAdmin.id === row.id}
                  >
                    <DeleteIcon
                      className={`table__delete ${
                        currentAdmin.id === row.id
                          ? "table__disabled"
                          : ""
                      }`}
                      fontSize="medium"
                    />
                  </IconButton>
                </span>
              </Tooltip>
            </TableCell>
          </TableRow>
        ))}
      />
      {!isLoading && !list.length && <EmptyState />}
      {meta.pages > 1 && (
        <Pagination
          count={meta.pages}
          page={meta.currentPage || page}
          handleChange={handlePagination}
        />
      )}
    </>
  );
};

AdminsList.propTypes = {
  lang: PropTypes.string
};

export default AdminsList;
